module.exports = __webpack_public_path__ + "img/co-branding-world-RP-2.a910ccc1.png";